// 失物招领 - 详情
import { useState, useEffect } from "react"
import { CloseOutlined } from '@ant-design/icons'

import { Modal } from "antd"

import ImgIconCollege from "@/assets/img/lost-and-found/icon-college.png"
import ImgNoImg from "@/assets/img/lost-and-found/no-img.png"

import "./info.less"

export default function Info(props) {
	const item = props.info

	const [current, setCurrent] = useState({ index: 0, img: "" })
	useEffect(() => {
		if (item.picUrlList?.length > 0) {
			setCurrent({ index: 0, img: item.picUrlList[0] })
		}
	}, [props.info])

	function clickImage(img, i) {
		setCurrent({ index: i, img })
	}

	return (
	<Modal open={props.visible} centered footer={null} width="925px" wrapClassName="pages_main_lost-and-found_info__outer"
			bodyStyle={{ padding: "0" }} closable={false} onCancel={props.onCancel}>
		<div className="pages_main_lost-and-found_info">
			<div className="item-close" onClick={props.onCancel}>
				<CloseOutlined className="close-icon" />
				<div className="close-label">关闭</div>
			</div>
			<div className="item-title">{ item.title }</div>
			<div className="item-line">
				{item.type == "LOST"
				? <div className="item-type item-type-lost">丢失</div>
				: <div className="item-type item-type-find">招领</div>
				}
				<div className="item-school">
					<img className="school-img" src={ImgIconCollege} />
					<div className="school-label">{ item.orgRegionName }</div>
				</div>
			</div>
			<div className="item-content">{ item.content }</div>
			{item.picUrlList?.length > 0
			? <div className="item-i">
				<img className="item-img-big" src={current.img} />
				<div className="item-imgs">
				{item.picUrlList.map((img, i) =>
					<div className={"item-img-item " + (current.index == i && "img-current")} key={i} onClick={() => clickImage(img, i)}>
						<img className="item-img" src={img} />
					</div>
				)}
				</div>
			</div>
			: <NoImg className="item-no-img" />
			}
		</div>
	</Modal>
	)
}

export function NoImg(props) {
	return <div className={"pages_main_lost-and-found_info__no-img " + (props.className || "")} style={props.style || {}}>
		<img className="no-img-img" src={ImgNoImg} />
		<div className="no-img-label">未上传图片</div>
	</div>
}
